import React, {useContext} from 'react';
import {Link} from "react-router-dom";
import {handleImageUrl, slugify} from "../../helpers";
import {LangContext} from "../../App";

const InfoItem = ({tour,path}) => {
    const lang = useContext(LangContext)
    const slug = slugify(tour?.title || '')
    return (
        <div className='info-item'>
            <img src={handleImageUrl(tour.thumbnail)} alt={tour.title}  style={{borderRadius:'10px'}}/>
            <div className="info-wrapper">
                <h2>{tour.title}</h2>
                <p>{tour.description}</p>
                <Link to={`/${lang}/${path}/${tour.id}/${slug}`} className='read-more'>Read more</Link>
            </div>
        </div>
    );
};

export default InfoItem;